module.exports = __webpack_public_path__ + "static/media/scotiabank.aa3a09ec.png";